import type { WeaponDefinition } from './types';

export class WeaponRegistry {
  private weapons = new Map<string, WeaponDefinition>();

  register(weapon: WeaponDefinition): void {
    this.weapons.set(weapon.id, weapon);
  }

  unregister(id: string): boolean {
    return this.weapons.delete(id);
  }

  get(id: string): WeaponDefinition | undefined {
    return this.weapons.get(id);
  }

  getAll(): WeaponDefinition[] {
    return Array.from(this.weapons.values());
  }

  getByCategory(category: string): WeaponDefinition[] {
    return this.getAll().filter((w) => w.category === category);
  }

  has(id: string): boolean {
    return this.weapons.has(id);
  }

  clear(): void {
    this.weapons.clear();
  }
}

export const weaponRegistry = new WeaponRegistry();
